module.exports = __webpack_public_path__ + "static/media/toyota.73d13d04.jpg";